import { AuditTemplate } from '../auditTypes';
import { DAILY } from './dailyAudits';
import { WEEKLY } from './weeklyAudits';
import { MONTHLY } from './monthlyAudits';
export { KEY_QUESTION_META } from '../auditTypes';
export { INTERVIEW_BANK } from './interviewBank';
export { q } from './q';
export const AUDIT_TEMPLATES: AuditTemplate[] = [...DAILY, ...WEEKLY, ...MONTHLY];
export const getTemplate = (id: string) => AUDIT_TEMPLATES.find(t => t.id === id);